import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer" id="contact" data-testid="footer">
      <div className="footer-grid">
        <div>
          <div className="footer-brand">
            <div className="brand-icon">U</div>
            <div className="footer-brand-text">
              <h4>Fertilizer Tracking</h4>
              <span>Smart Fertilizer Tracking</span>
            </div>
          </div>
          <p className="desc">
            Fertilizer Tracking is the national QR-based traceability platform for subsidised
            Fertilizer — protecting farmers, empowering officials and securing every bag
            from factory to field.
          </p>
          <div className="socials">
            <a href="#" aria-label="Twitter"><i className="fa-brands fa-x-twitter"></i></a>
            <a href="#" aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in"></i></a>
            <a href="#" aria-label="YouTube"><i className="fa-brands fa-youtube"></i></a>
            <a href="#" aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
          </div>
        </div>

        <div>
          <h4>Useful Links</h4>
          <ul>
            <li><a href="#about"><i className="fa-solid fa-chevron-right"></i> About Fertilizer Tracking</a></li>
            <li><a href="#how"><i className="fa-solid fa-chevron-right"></i> How It Works</a></li>
            <li><a href="#features"><i className="fa-solid fa-chevron-right"></i> Features</a></li>
            <li><a href="#why"><i className="fa-solid fa-chevron-right"></i> Why Us</a></li>
            <li><a href="#"><i className="fa-solid fa-chevron-right"></i> Press &amp; Media</a></li>
          </ul>
        </div>

        <div>
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/login"><i className="fa-solid fa-chevron-right"></i> Admin Portal</Link></li>
            <li><a href="#"><i className="fa-solid fa-chevron-right"></i> Dealer Onboarding</a></li>
            <li><a href="#"><i className="fa-solid fa-chevron-right"></i> Farmer Helpline</a></li>
            <li><a href="#"><i className="fa-solid fa-chevron-right"></i> API Documentation</a></li>
            <li><a href="#"><i className="fa-solid fa-chevron-right"></i> Privacy &amp; Terms</a></li>
          </ul>
        </div>

        <div>
          <h4>Contact</h4>
          <div className="contact-line">
            <i className="fa-solid fa-headset"></i>
            <div>
              <strong>Helpline</strong>
              1800-180-1551 (Toll-free)
            </div>
          </div>
          <div className="contact-line">
            <i className="fa-solid fa-envelope"></i>
            <div>
              <strong>Email</strong>
              support@fertilizertracking.com
            </div>
          </div>
          <div className="contact-line">
            <i className="fa-solid fa-location-dot"></i>
            <div>
              <strong>HQ Address</strong>
              Nehru Place, New Delhi 110019, India
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div>© {new Date().getFullYear()} Fertilizer Tracking. All rights reserved.</div>
      </div>

      <Link to="/login" className="scan-fab" aria-label="Admin login" data-testid="scan-fab">
        <i className="fa-solid fa-qrcode"></i>
      </Link>
    </footer>
  );
}
